import { render } from "./Corps.vue?vue&type=template&id=df2bd1f8"
import script from "./Corps.vue?vue&type=script&lang=js"
export * from "./Corps.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__